import {ReportDetailItem} from './report-detail-contract-item.model';

export class ListReportDetailContractResponse {
    page: number;
    maxSize: number;
    sort: string;
    propertiesSort: string;
    totalElement: number;
    data: ReportDetailItem[] = [];

    constructor(obj = null) {
        obj = obj || {};
        this.page = obj.page || 1;
        this.maxSize = obj.maxSize || 10;
        this.sort = obj.sort || '';
        this.propertiesSort = obj.propertiesSort || '';
        this.totalElement = obj.totalElement || 0;

        this.data = [];
        if (obj.data && obj.data instanceof Array) {
            obj.data.forEach((item) => {
                this.data.push(new ReportDetailItem(item));
            })
        }
    }
}
